import axios from 'axios'

export const getDocs = async () => {
  try {
    const res = await axios.get('/api/api-doc/v2/docs')
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getDoc = async (docId) => {
  const encodedDocId = encodeURIComponent(docId)
  try {
    const res = await axios.get(`/api/api-doc/v2/doc/${encodedDocId}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const createDoc = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v2/docs', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const updateDoc = async (data) => {
  const encodedDocId = encodeURIComponent(data.docId)
  try {
    const res = await axios.post(`/api/api-doc/v2/docs/${encodedDocId}`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const deleteDoc = async (docId) => {
  const encodedDocId = encodeURIComponent(docId)
  try {
    const res = await axios.post(`/api/api-doc/v2/docs/${encodedDocId}/delete`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const batchDeleteDocs = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v2/docs/batch-delete', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getSections = async () => {
  try {
    const res = await axios.get('/api/api-doc/v2/sections')
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getSectionsByDocId = async (docId) => {
  const encodedDocId = encodeURIComponent(docId)
  try {
    const res = await axios.get(`/api/api-doc/v2/sections/${encodedDocId}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getSection = async ({ docId, sectionId }) => {
  const encodedDocId = encodeURIComponent(docId)
  const encodedSectionId = encodeURIComponent(sectionId)
  try {
    const res = await axios.get(`/api/api-doc/v2/sections/${encodedDocId}/${encodedSectionId}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const createSection = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v2/sections', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const updateSection = async (data) => {
  const encodedDocId = encodeURIComponent(data.docId)
  const encodedSectionId = encodeURIComponent(data.sectionId)
  try {
    const res = await axios.post(`/api/api-doc/v2/sections/${encodedDocId}/${encodedSectionId}`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const batchWriteSections = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v2/sections/batch-write', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const deleteSection = async ({ sectionId, docId }) => {
  const encodedDocId = encodeURIComponent(docId)
  const encodedSectionId = encodeURIComponent(sectionId)
  try {
    const res = await axios.post(`/api/api-doc/v2/sections/${encodedDocId}/${encodedSectionId}/delete`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const batchDeleteSections = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v2/sections/batch-delete', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getManagment = async () => {
  try {
    const res = await axios.get('/api/api-doc/v2/management')
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getManagementByEntityType = async (entityType) => {
  try {
    const res = await axios.get(`/api/api-doc/v2/management/${entityType}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const getManagementByEntityTypeAndId = async (entityType, id) => {
  try {
    const res = await axios.get(`/api/api-doc/v2/management/${entityType}/${id}`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const createManagementItem = async (data) => {
  try {
    const res = await axios.post(`/api/api-doc/v2/management/${data.entityType}`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const updateManagementItem = async (data) => {
  try {
    const res = await axios.post(`/api/api-doc/v2/management/${data.entityType}/${data.id}`, data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const deleteManagementItem = async ({ entityType, id }) => {
  try {
    const res = await axios.post(`/api/api-doc/v2/management/${entityType}/${id}/delete`)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const uploadImage = async (data) => {
  try {
    const res = await axios.post('/api/api-doc/v2/upload', data)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}

export const deleteImages = async (fileNames) => {
  try {
    const res = await axios.post('/api/api-doc/v2/upload/delete', fileNames)
    return res.data
  } catch (error) {
    console.error(error)
    const { data: errData } = error.response || {}
    return errData
  }
}
